import { Cube } from "../../FuturebilityCockpit/components/Сube";
import { CubeSideName } from "../../FuturebilityCockpit/components/Сube/types";
import { SideScore } from "./components/Score";
import { CalculationType } from "../../FuturebilityCockpit/types";
import { CubeSideData } from "../../FuturebilityCockpit/hooks/useCategoryPageData/types";
import { CUBE_SIDE_NAMES } from "../../FuturebilityCockpit/components/Сube/constants";

import "./ExtendedCube.scss";

export interface ExtendedCubeProps {
  scaleFactor: number;
  cubeSidesData: Record<CubeSideName, CubeSideData>;
  scoreCalculationType: CalculationType;
  showBenchmark: boolean;
}

export function ExtendedCube({
  scaleFactor,
  cubeSidesData,
  scoreCalculationType,
  showBenchmark,
}: ExtendedCubeProps) {
  const renderSideScore = (side: CubeSideName) => (
    <SideScore
      percent={cubeSidesData[side][scoreCalculationType]["percentageValue"]}
      benchmark={showBenchmark ? cubeSidesData[side].benchmark : undefined}
      title={cubeSidesData[side].title ?? side}
      color="#ffffff"
    />
  );

  return (
    <div className="extended-cube-data">
      <div className="row justify-center">{renderSideScore("2")}</div>
      <div className="row justify-center">
        <div
          className="side-group left"
          style={{ gap: `calc(127px * ${scaleFactor})` }}
        >
          {renderSideScore("5")}
          {renderSideScore("4")}
        </div>
        <div className="row justify-center">
          <Cube
            greyOutOtherSidesOnHover
            scale={scaleFactor}
            values={CUBE_SIDE_NAMES.reduce((acc, side) => {
              acc[side] =
                cubeSidesData[side][scoreCalculationType]["cubeSideFillArea"];
              return acc;
            }, {} as Record<CubeSideName, number>)}
          />
        </div>
        <div
          className="side-group right"
          style={{ gap: `calc(127px * ${scaleFactor})` }}
        >
          {renderSideScore("6")}
          {renderSideScore("3")}
        </div>
      </div>
      <div className="row justify-center">{renderSideScore("1")}</div>
    </div>
  );
}
